<template>
  <div @click="$router.push({name: 'invoice-show', params: {id: id}})" class="loans_item">
    <div style="height: 100%" class="invoice-number">	
	    <span> {{ number }} </span> 
    </div>
    <div class="loans_item-price">
	    {{ total }}
    </div>
    <div class="loans_item-grey-text">
      <span>Date</span>
      <span>{{ date }}</span>
    </div>
    <div class="loans_item-grey-text">
      <span>Vendedor</span>
      <span>{{ seller }}</span>
    </div>
    <div class="loans_item-rate" :class=" status === 'closed' ? 'close-status' : 'open-status'">
	    <span> Estado </span>
	    <span> {{ status }} </span>
    </div>
    <div class="loans_item-grey-text" id="period">
      <span>Saldo</span>
      <span>{{ remaining }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      default: 0,
      type: Number
    },
    number: {
      default: 0,
      type: Number
    },
    total: {
      default: 0,
      type: String
    },
    date: {
      default: "",
      type: String
    },
    seller: {
      default: "",
      type: String
    },
    status: {
      default: "",
      type: String
    },
    remaining: {
      default: 0,
      type: String
    }
  }
}
</script>
